module.exports = __webpack_public_path__ + "img/148.123b319e.jpg";